import React, { useEffect, useRef, useState } from "react";
import { useReactToPrint } from "react-to-print";
import { useLocation, useNavigate } from "react-router";
import { Button, Typography } from "@mui/material";
import axios from "axios";
import { commonUrl, redirectUrl } from "src/config";

const ProductWisePrint = () => {
  const { state } = useLocation();
  const navigate = useNavigate();
  const componentRef = useRef();

  const { header = {}, table = [] } = state || {};

  const { fromDate, toDate, product, branch } = header;

  const [company, setCompany] = useState(null);

  useEffect(() => {
    function getStatusDatas() {
      axios
        .get(commonUrl + "main/getCompanyDetails", { withCredentials: true })
        .then((res) => {
          if (res.data[0]) {
            setCompany(res?.data[0]);
          }
        })
        .catch((err) => {
          if (err.response?.status === 401 || err.response?.status === 403) {
            window.location.href = redirectUrl;
          }
          alert(err);
        });
    }

    getStatusDatas();
  }, []);

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    documentTitle: `ProductWiseReport from ${fromDate} to ${toDate}`,
    onAfterPrint: () => navigate(-1), // Navigate back after printing
  });

  useEffect(() => {
    if (company) {
      // Short delay to ensure rendering is complete before triggering print
      const timer = setTimeout(() => {
        handlePrint();
      }, 500);
      return () => clearTimeout(timer);
    }
  }, [company]);

  const totalQuantity = table.reduce(
    (sum, row) => sum + Number(row.quantity || 0),
    0
  );
  const totalAmount = table.reduce(
    (sum, row) => sum + Number(row.totalAmount || 0),
    0
  );

  return (
    <div style={{ padding: "12px" }}>
      {/* Buttons hidden as they are no longer needed with auto-print */}
      <div style={{ marginBottom: "10px", display: "none" }}>
        <Button variant="contained" onClick={handlePrint}>
          Print
        </Button>
        <Button style={{ marginLeft: "10px" }} onClick={() => navigate(-1)}>
          Back
        </Button>
      </div>

      <div
        ref={componentRef}
        style={{
          backgroundColor: "#fff",
          padding: "25px",
          fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
        }}
      >
        <div style={{ textAlign: "center" }}>
          <h3>{company?.Name}</h3>
          <p>
            {company?.Add1} {company?.Place}
          </p>
          <p>{company?.Ph}</p>
        </div>

        <div
          style={{
            color: "#000",
            padding: "16px",
            borderRadius: "6px",
            marginBottom: "20px",
            textAlign: "center",
          }}
        >
          <Typography variant="h5" style={{ fontWeight: "bold" }}>
            PRODUCT WISE REPORT
          </Typography>
          <div style={{ display: "flex", justifyContent: "center", gap: 10 }}>
            <Typography variant="subtitle1">From: {fromDate}</Typography>
            <Typography variant="subtitle1">To: {toDate}</Typography>
            <Typography variant="subtitle1">Type: {header.type}</Typography>
          </div>
        </div>

        <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "10px" }}>
          <Typography variant="subtitle1">
            Branch: {branch?.label || "ALL"}
          </Typography>
          <Typography variant="subtitle1">
            Product: {product?.productName || "ALL"}
          </Typography>
        </div>

        <table
          style={{
            width: "100%",
            textAlign: "center",
            fontSize: "13px",
            borderCollapse: "collapse",
            marginBottom: "20px",
          }}
        >
          <thead style={{ backgroundColor: "#f0f0f0" }}>
            <tr>
              {[
                "SI",
                "Date",
                "Bill No",
                "Customer",
                "Product Name",
                "Quantity",
                "Rate",
                "Total Amount",
              ].map((h, i) => (
                <th
                  key={i}
                  style={{
                    border: "1px solid #ccc",
                    padding: "8px",
                    fontWeight: "bold",
                  }}
                >
                  {h}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {table.map((row, idx) => (
              <tr
                key={idx}
                style={{
                  backgroundColor: idx % 2 === 0 ? "#fafafa" : "#fff",
                  pageBreakInside: "avoid"
                }}
              >
                <td style={{ border: "1px solid #ccc", padding: "6px" }}>
                  {idx + 1}
                </td>
                <td style={{ border: "1px solid #ccc", padding: "6px" }}>
                  {row.date}
                </td>
                <td style={{ border: "1px solid #ccc", padding: "6px" }}>
                  {row.billNo}
                </td>
                <td style={{ border: "1px solid #ccc", padding: "6px", textAlign: "left" }}>
                  {row.customerName}
                </td>
                <td style={{ border: "1px solid #ccc", padding: "6px", textAlign: "left" }}>
                  {row.productName}
                </td>
                <td style={{ border: "1px solid #ccc", padding: "6px" }}>
                  {row.quantity}
                </td>
                <td style={{ border: "1px solid #ccc", padding: "6px" }}>
                  {row.rate}
                </td>
                <td style={{ border: "1px solid #ccc", padding: "6px" }}>
                  {Number(row.totalAmount).toFixed(2)}
                </td>
              </tr>
            ))}
            {/* Total Row moved inside tbody */}
            <tr style={{ fontWeight: 'bold', backgroundColor: '#eee', pageBreakInside: "avoid" }}>
              <td colSpan={5} style={{ border: "1px solid #ccc", padding: "8px", textAlign: "right" }}>Total:</td>
              <td style={{ border: "1px solid #ccc", padding: "8px" }}>{totalQuantity}</td>
              <td style={{ border: "1px solid #ccc", padding: "8px" }}></td>
              <td style={{ border: "1px solid #ccc", padding: "8px" }}>{totalAmount.toFixed(2)}</td>
            </tr>
          </tbody>
        </table>

        <hr />
      </div>
    </div>
  );
};

export default ProductWisePrint;

